import React, { FunctionComponent } from 'react';

import { MotorFullPageProps } from 'scenes/motor/types';
import { PolicyStartDateStep as CommonPolicyStartDate } from 'scenes/common/components/Steps';
import { getPolicyStartDate } from 'scenes/motor/selectors';
import { InterstitialModal } from 'scenes/motor/components/InterstitialModal';
import { useIntersitialContext } from 'scenes/motor/context';
import { isBeforeEffectiveEndDate } from 'scenes/common/selectors/configSelectors';

const PolicyStartDateStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
}) => {
  const [value] = useIntersitialContext();
  return (
    <>
      {value.preQuote && <InterstitialModal preQuote />}
      <CommonPolicyStartDate
        defaultStateValue={getPolicyStartDate(funnelState)}
        onNext={onNext}
        isBeforeEffectiveEndDate={isBeforeEffectiveEndDate(
          funnelState.apiResponses.config
        )}
      />
    </>
  );
};

export default PolicyStartDateStep;
